import React, { useState } from "react";
import { connect } from "react-redux";
import { RootState } from "Realty/store";
import { Modal } from "../../../../../../components/common/Modal";
import { ReactComponent as FiltersIcon } from "../../../../../../assets/icons/filters.svg";
import "./styles.css";
import { Input } from "../../../../../../components/common/Input";
import {
  selectAreaWorthMin,
  selectAreaWorthMax,
  selectFullPriceMin,
  selectFullPriceMax,
  selectRequiredPaymentMin,
  selectRequiredPaymentMax,
  selectMonthlyPaymentMin,
  selectMonthlyPaymentMax,
} from "../../../../../../store/ContractAssignment/selectors";
import { ContractAssignmentActionCreator } from "../../../../../../store/ContractAssignment/actions";
import { Button } from "../../../../../../components/common/Button";
import { RangeSlider } from "../../../../../../components/common/RangeSlider";
import {
  areaWorthStepConfig,
  FILTER_LIMITS, fullPriceStepConfig,
  monthlyPaymentStepConfig,
} from "./constants";

export const _Filters = ({
  fullPriceMin,
  fullPriceMax,
  areaWorthMin,
  areaWorthMax,
  requiredPaymentMin,
  requiredPaymentMax,
  monthlyPaymentMin,
  monthlyPaymentMax,
  setFullPriceMin,
  setFullPriceMax,
  setAreaWorthMin,
  setAreaWorthMax,
  setRequiredPaymentMin,
  setRequiredPaymentMax,
  setMonthlyPaymentMin,
  setMonthlyPaymentMax,
  clearFilters,
  sendRequest,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleApply = () => {
    sendRequest();
    setIsOpen(false);
  };

  // Функция-клэмпер для ограничения значения между min и max
  const clamp = (value: number, min: number, max: number) =>
    Math.max(min, Math.min(value, max));

  // Обработчики для "Полной стоимости"
  const handleFullPriceMinChange = (newMin: number) => {
    const clampedValue = clamp(
      newMin,
      FILTER_LIMITS.fullPrice.min,
      FILTER_LIMITS.fullPrice.max,
    );
    if (clampedValue > fullPriceMax) {
      setFullPriceMin(fullPriceMax);
    } else {
      setFullPriceMin(clampedValue);
    }
  };

  const handleFullPriceMaxChange = (newMax: number) => {
    const clampedValue = clamp(
      newMax,
      FILTER_LIMITS.fullPrice.min,
      FILTER_LIMITS.fullPrice.max,
    );
    if (clampedValue < fullPriceMin) {
      setFullPriceMax(fullPriceMin);
    } else {
      setFullPriceMax(clampedValue);
    }
  };

  // Обработчики для "Взноса"
  const handleRequiredPaymentMinChange = (newMin: number) => {
    const clampedValue = clamp(
      newMin,
      FILTER_LIMITS.requiredPayment.min,
      FILTER_LIMITS.requiredPayment.max,
    );
    if (clampedValue > requiredPaymentMax) {
      setRequiredPaymentMin(requiredPaymentMax);
    } else {
      setRequiredPaymentMin(clampedValue);
    }
  };

  const handleRequiredPaymentMaxChange = (newMax: number) => {
    const clampedValue = clamp(
      newMax,
      FILTER_LIMITS.requiredPayment.min,
      FILTER_LIMITS.requiredPayment.max,
    );
    if (clampedValue < requiredPaymentMin) {
      setRequiredPaymentMax(requiredPaymentMin);
    } else {
      setRequiredPaymentMax(clampedValue);
    }
  };

  // Обработчики для "Стоимость за квадрат"
  const handleAreaWorthMinChange = (newMin: number) => {
    const clampedValue = clamp(
      newMin,
      FILTER_LIMITS.areaWorth.min,
      FILTER_LIMITS.areaWorth.max,
    );
    if (clampedValue > areaWorthMax) {
      setAreaWorthMin(areaWorthMax);
    } else {
      setAreaWorthMin(clampedValue);
    }
  };

  const handleAreaWorthMaxChange = (newMax: number) => {
    const clampedValue = clamp(
      newMax,
      FILTER_LIMITS.areaWorth.min,
      FILTER_LIMITS.areaWorth.max,
    );
    if (clampedValue < areaWorthMin) {
      setAreaWorthMax(areaWorthMin);
    } else {
      setAreaWorthMax(clampedValue);
    }
  };

  // Обработчики для "Ежемесячного платежа"
  const handleMonthlyPaymentMinChange = (newMin: number) => {
    const clampedValue = clamp(
      newMin,
      FILTER_LIMITS.monthlyPayment.min,
      FILTER_LIMITS.monthlyPayment.max,
    );
    if (clampedValue > monthlyPaymentMax) {
      setMonthlyPaymentMin(monthlyPaymentMax);
    } else {
      setMonthlyPaymentMin(clampedValue);
    }
  };

  const handleMonthlyPaymentMaxChange = (newMax: number) => {
    const clampedValue = clamp(
      newMax,
      FILTER_LIMITS.monthlyPayment.min,
      FILTER_LIMITS.monthlyPayment.max,
    );
    if (clampedValue < monthlyPaymentMin) {
      setMonthlyPaymentMax(monthlyPaymentMin);
    } else {
      setMonthlyPaymentMax(clampedValue);
    }
  };

  return (
    <>
      <button className="filters_toggle-button" onClick={() => setIsOpen(true)}>
        <FiltersIcon fill="#000" width="20px" height="20px" />
      </button>
      <Modal
        title="Фильтры"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        actionButtonText="применить"
        actionButtonCallback={handleApply}
      >
        {/* Фильтр "Полная стоимость" */}
        <div className="filters_item">
          <div className="filters_item-title">Полная стоимость</div>
          <div className="filters_item_body">
            <Input
              value={fullPriceMin}
              onChange={handleFullPriceMinChange}
              type="number"
              placeholder="минимум"
              min={FILTER_LIMITS.fullPrice.min}
              max={fullPriceMax} // максимальное для инпута минимума – текущее значение максимума
            />
            <Input
              value={fullPriceMax}
              onChange={handleFullPriceMaxChange}
              type="number"
              placeholder="максимум"
              min={fullPriceMin} // минимальное для инпута максимума – текущее значение минимума
              max={FILTER_LIMITS.fullPrice.max}
            />
          </div>
          <RangeSlider
            min={FILTER_LIMITS.fullPrice.min}
            max={FILTER_LIMITS.fullPrice.max}
            valueMin={fullPriceMin}
            valueMax={fullPriceMax}
            onChangeMin={setFullPriceMin}
            onChangeMax={setFullPriceMax}
            stepConfig={fullPriceStepConfig}
          />
        </div>

        {/* Фильтр "Взнос" */}
        <div className="filters_item">
          <div className="filters_item-title">Взнос</div>
          <div className="filters_item_body">
            <Input
              value={requiredPaymentMin}
              onChange={handleRequiredPaymentMinChange}
              type="number"
              placeholder="минимум"
              min={FILTER_LIMITS.requiredPayment.min}
              max={requiredPaymentMax}
            />
            <Input
              value={requiredPaymentMax}
              onChange={handleRequiredPaymentMaxChange}
              type="number"
              placeholder="максимум"
              min={requiredPaymentMin}
              max={FILTER_LIMITS.requiredPayment.max}
            />
          </div>
          <RangeSlider
            min={FILTER_LIMITS.requiredPayment.min}
            max={FILTER_LIMITS.requiredPayment.max}
            valueMin={requiredPaymentMin}
            valueMax={requiredPaymentMax}
            onChangeMin={setRequiredPaymentMin}
            onChangeMax={setRequiredPaymentMax}
            stepConfig={fullPriceStepConfig}
          />
        </div>

        {/* Фильтр "Стоимость за квадрат" */}
        <div className="filters_item">
          <div className="filters_item-title">Стоимость за квадрат</div>
          <div className="filters_item_body">
            <Input
              value={areaWorthMin}
              onChange={handleAreaWorthMinChange}
              type="number"
              placeholder="минимум"
              min={FILTER_LIMITS.areaWorth.min}
              max={areaWorthMax}
            />
            <Input
              value={areaWorthMax}
              onChange={handleAreaWorthMaxChange}
              type="number"
              placeholder="максимум"
              min={areaWorthMin}
              max={FILTER_LIMITS.areaWorth.max}
            />
          </div>
          <RangeSlider
            min={FILTER_LIMITS.areaWorth.min}
            max={FILTER_LIMITS.areaWorth.max}
            valueMin={areaWorthMin}
            valueMax={areaWorthMax}
            onChangeMin={setAreaWorthMin}
            onChangeMax={setAreaWorthMax}
            stepConfig={areaWorthStepConfig}
          />
        </div>

        {/* Фильтр "Ежемесячный платеж" */}
        <div className="filters_item">
          <div className="filters_item-title">Ежемесячный платеж</div>
          <div className="filters_item_body">
            <Input
              value={monthlyPaymentMin}
              onChange={handleMonthlyPaymentMinChange}
              type="number"
              placeholder="минимум"
              min={FILTER_LIMITS.monthlyPayment.min}
              max={monthlyPaymentMax}
            />
            <Input
              value={monthlyPaymentMax}
              onChange={handleMonthlyPaymentMaxChange}
              type="number"
              placeholder="максимум"
              min={monthlyPaymentMin}
              max={FILTER_LIMITS.monthlyPayment.max}
            />
          </div>
          <RangeSlider
            min={FILTER_LIMITS.monthlyPayment.min}
            max={FILTER_LIMITS.monthlyPayment.max}
            valueMin={monthlyPaymentMin}
            valueMax={monthlyPaymentMax}
            onChangeMin={setMonthlyPaymentMin}
            onChangeMax={setMonthlyPaymentMax}
            stepConfig={monthlyPaymentStepConfig}
          />
        </div>

        <Button
          className="filters_clear-button"
          text="сброс"
          onClick={() => clearFilters()}
          fullWidth
          variant="secondary"
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  fullPriceMin: selectFullPriceMin(state),
  fullPriceMax: selectFullPriceMax(state),
  areaWorthMin: selectAreaWorthMin(state),
  areaWorthMax: selectAreaWorthMax(state),
  requiredPaymentMin: selectRequiredPaymentMin(state),
  requiredPaymentMax: selectRequiredPaymentMax(state),
  monthlyPaymentMin: selectMonthlyPaymentMin(state),
  monthlyPaymentMax: selectMonthlyPaymentMax(state),
});

const mapDispatchToProps = {
  setFullPriceMin: ContractAssignmentActionCreator.setFullPriceMin,
  setFullPriceMax: ContractAssignmentActionCreator.setFullPriceMax,
  setAreaWorthMin: ContractAssignmentActionCreator.setAreaWorthMin,
  setAreaWorthMax: ContractAssignmentActionCreator.setAreaWorthMax,
  setRequiredPaymentMin: ContractAssignmentActionCreator.setRequiredPaymentMin,
  setRequiredPaymentMax: ContractAssignmentActionCreator.setRequiredPaymentMax,
  setMonthlyPaymentMin: ContractAssignmentActionCreator.setMonthlyPaymentMin,
  setMonthlyPaymentMax: ContractAssignmentActionCreator.setMonthlyPaymentMax,
  clearFilters: ContractAssignmentActionCreator.clearFilters,
};

export const Filters = connect(mapStateToProps, mapDispatchToProps)(_Filters);
